// extracted by mini-css-extract-plugin
export default {"card":"rZqf91NYiKWZLvKtx0_r","title":"LZGwL9ccOgVfKYsrmD9P","chart":"xbE00U00xNlYtJz2e0AK","footer":"o63m9kumGmEvvspi_s2v"};